import React from 'react';
import PropTypes from 'prop-types';
import CustomDialog from '@/components/common/CustomDialog';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { ConstituentAssigneeSelect } from '@/modules/ConstituentDetails';
import { TaskStatusEnum } from '../tasksConfig';

function TaskFilterDialog({
  children,
  filters,
  onClose,
  onFilterUpdate,
  open,
}) {
  const onSubmit = () => {
    onClose();
  };

  return (
    <CustomDialog
      dialogHeader={translate('TASKS_FILTER_LIST')}
      actionButtonLabel={translate('TASKS_UPDATE_LIST')}
      handleActionButton={onSubmit}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      open={open}
    >
      <ConstituentAssigneeSelect
        name="userId"
        className="mb-6 flex w-full"
        onChange={onFilterUpdate}
        value={filters.users || TaskStatusEnum.ALL}
      />
      {children}
    </CustomDialog>
  );
}

TaskFilterDialog.propTypes = {
  children: PropTypes.node,
  filters: PropTypes.shape({
    users: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func,
  onFilterUpdate: PropTypes.func,
  open: PropTypes.bool,
};

TaskFilterDialog.defaultProps = {
  children: null,
  onClose: () => {},
  onFilterUpdate: () => {},
  open: false,
};

export default TaskFilterDialog;
